/**
 * Created by neo on 07.05.21.
 */
import { makeAutoObservable } from 'mobx';
import { GoogleTtsAudioConfig, createGoogleTtsAudioConfig } from './GoogleTtsAudioConfig';
import { GoogleTtsInput, createGoogleTtsInput } from './GoogleTtsInput';
import { GoogleTtsVoice, createGoogleTtsVoice } from './GoogleTtsVoice';

export type GoogleTtsRequest = {
  audioConfig: GoogleTtsAudioConfig;
  input: GoogleTtsInput;
  voice: GoogleTtsVoice;
};

export function createGoogleTtsRequest(json?: Partial<GoogleTtsRequest>): GoogleTtsRequest {
  return makeAutoObservable({
    audioConfig: createGoogleTtsAudioConfig(json?.audioConfig),
    input: createGoogleTtsInput(json?.input),
    voice: createGoogleTtsVoice(json?.voice),
  });
}
